import template from './sw-cms-block-category-navigation.html.twig';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
